import React, { Component } from 'react';
import * as pt from 'prop-types';
import xhr from 'xhr';
import MdCallMade from 'react-icons/lib/md/call-made';
import _ from 'underscore';

import Loader from '../../../../../common/components/notifications/Loader';
import TranscriptPlayer from './TranscriptPlayer';

class TranscriptEditModal extends Component {
    constructor (props) {
        super(props);

        this.state = {
            edits: false,
            edited: false,

            original: false,

            resolving: true,

            hasError: false
        };

        this.resubmitTranscript = this.resubmitTranscript.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidCatch (error, info) {
        this.setState({ hasError: true });
    }

    componentWillMount () {
        if (this.props.transcript.data.text) {
            const self = this;
            xhr.get(
                this.props.transcript.data.text,
                function (err, resp, body) {
                    self.setState({
                        original: (err || body === null) ? false : body,
                        resolving: false
                    });
                }
            );
        }
    }

    resubmitTranscript (ev) {
        this.props.actions.transcript.resubmit({
            eventID: this.props.eventID,
            submissionText: this.state.edits
        });
    }

    handleChange (event) {
        this.setState({
            edited: true,
            edits: event.target.value
        });
    }

    render () {
        if (this.state.resolving) return <Loader message="Fetching"/>;

        const { edited, edits } = this.state;
        var { requests } = this.props;
        var resubmitResolving = Boolean(_(requests.resolving).findWhere({
            type: 'resubmit'
        }));

        var submitIcon = resubmitResolving ?
            <i className="fa fa-circle-notch fa-spin fa-fw"></i> :
            <MdCallMade />

        return (<div className="row">
            <br/>

            <div className="col-md-4">
                <TranscriptPlayer {...this.props}/>
            </div>

            <div className="col-md-8">
                <textarea
                    name="transcription"
                    value={this.state.edited ?
                        this.state.edits :
                        (this.state.original !== false) ? this.state.original : ''
                    }
                    placeholder={this.state.original === false ? 'No Transcript Available' : 'Required'}
                    style={{
                        maxWidth: '100%',
                        minWidth: '100%',
                        padding: '1rem',
                        minHeight: '350px',
                        border: '1px solid #ccc'
                    }}
                    onChange={this.handleChange}>
                </textarea>
            </div>

            <br/>

            <div className="col-xs-12 text-right">
                <button className="btn btn-link"
                    onClick={this.props.cancelModal}
                    disabled={resubmitResolving}
                >
                    Cancel
                </button>

                <button className="btn btn-success"
                    onClick={this.resubmitTranscript}
                    disabled={edited === false || edits === "" ||
                        resubmitResolving}
                    >
                    {submitIcon} Submit for Re-transcription
                </button>
            </div>
        </div>)
    }
}

TranscriptEditModal.propTypes = {};

export default TranscriptEditModal;
